import React from "react";
import "./HomeContent.css";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const InformationSection = () => {
  return (
    <section className="information-section">
      <div className="info-text">
        <p>
          How to find the products you see in
          <br></br>
          <span className="brand-name">Bodyfriend</span>
          <br></br>
          advertisements in your home
        </p>
      </div>
      <div className="info-actions">
        <div className="action-item">
          <SupportAgentIcon style={{ fontSize: 60 }} className="action-image" />
          <div className="action-details">
            <span className="action-title">Need help?</span>
            <a href="/contact-us" className="action-link">
              Contact Us Now &gt;
            </a>
          </div>
        </div>
        {/* <div className="action-item">
          <img
            className="action-image"
            src={require("../../Components/Assets/icon/experience.png")}
            alt="Experience"
          />
          <div className="action-details">
            <span className="action-title">Experience it for yourself</span>
            <a href="#" className="action-link">
              Book an experience at a lounge near you &gt;
            </a>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default InformationSection;
